import { Component, OnInit, Inject, Output, EventEmitter } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { cloneDeep } from "lodash";
import { Constants } from "../../../../core/services/constants";
import { Schedule, WeekDay, Scheduling } from "../../scheduling.model";
import { ScheduleType } from "../../../../shared/constants";
import { SCHEDULE_TYPE } from "../../scheduling.constants";
import { HVACModel } from "../../../devices/devices.utils";

@Component({
  selector: "app-scheduling-create-dialog",
  templateUrl: "./scheduling-create-dialog.component.html",
  styleUrls: ["./scheduling-create-dialog.component.scss"],
})
export class SchedulingCreateDialogComponent {
  loading;
  schedule: Schedule;
  types: SCHEDULE_TYPE[];
  scheduling: Scheduling;
  schedulingStandbyKiller: Scheduling;
  schedulingEconomic: Scheduling;
  hvacModel: HVACModel;
  termostatModel: boolean;
  errorMessage: string;

  @Output() action: EventEmitter<Schedule> = new EventEmitter<Schedule>();

  constructor(
    public dialogRef: MatDialogRef<SchedulingCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.schedule = data.schedule;
    this.scheduling = data.scheduling;
    this.schedulingStandbyKiller = data.schedulingSK;
    this.schedulingEconomic = data.schedulingEco;
    this.types = data.types;
    this.hvacModel = data.hvacModel;
    this.termostatModel = data.termostatModel;
    this.errorMessage = "";
  }

  onScheduleEmit(schedule: Schedule): void {
    // console.log(schedule);
    this.loading = true;
    this.action.emit(schedule);
  }

  onCloseDialog() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/scheduling/scheduling-device/scheduling-create-dialog/scheduling-create-dialog.component.ts